import React, { useState } from "react";
import { polyhouseImages } from "./polyhouseImages";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Footer from "../../Components/Footer/footer";
import FooterwithoutLogin from "../../Pages Without Login/controllEnvironmentPolyhouse/footerwithoutLogin";
import { enquiryInfo } from "../../SchemaInfo/enquiryInfo";
import { enquirySchema } from "../../Schemas/Enquiry/enquiry_schema";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { Formik, Form } from "formik";
import { BsBoxArrowInRight } from "react-icons/bs";
import CustomInput from "../../CustomComponent/custom_input";
import LoadingPage from "../../Components/layouts/loading";

function Polyhouseseopages() {
  const { length, width } = useParams();
  const [loading, setLoading] = useState(false);

  const getImagesForSize = (length, width) => {
    const sizeObj = polyhouseImages.find(
      (item) => item.length === Number(length) && item.width === Number(width)
    );
    return sizeObj ? sizeObj.images : null;
  };

  const image = getImagesForSize(length, width);

  const [images, setImages] = useState(image);

  if (!images)
    return (
      <div className="container py-5 text-center">
        <h2>No Images Found</h2>
        <p>
          Sorry, we don’t have layout images for {length} × {width} polyhouse
          yet.
        </p>
      </div>
    );

  let hydrponicPercentage = 100;
  let indexCount = 0;
  let Sqmtr = +length * +width;
  let SqFt = Math.ceil(Sqmtr * 10.764);
  let UsableSqMtr = (+length - 4) * (+width - 4); // this four maybe from the hockey length and width which is 4
  let HockeyLength = 4;
  let HockeyWidth = 4;
  let AvailableLength = +length - HockeyLength;
  let AvailableWidth = +width - HockeyWidth;
  let LengthBreakdown = AvailableLength / 4;
  let WidthBreakdown = AvailableWidth / 8;
  let TotalBlocks8X4Mtr = LengthBreakdown * WidthBreakdown;
  let Lenghtinft = (AvailableLength * 3.281).toFixed(3); // 1 meter=3.28084 feet round of 3.281
  let Widthinft = (AvailableWidth * 3.281).toFixed(3);
  let UsableWidth = Math.ceil(Widthinft - 5);
  let availWidth = width - 4;
  let growbagLines = (availWidth / 8) * 6;
  // Finding totalflatbed
  let TotalFlatbed;

  if (+hydrponicPercentage == 25) {
    TotalFlatbed = (TotalBlocks8X4Mtr / 4) * 2;
  } else if (+hydrponicPercentage == 50) {
    TotalFlatbed = (TotalBlocks8X4Mtr / 2) * 2;
  } else if (+hydrponicPercentage == 75) {
    TotalFlatbed = ((TotalBlocks8X4Mtr * 3) / 2) * 2;
  } else if (+hydrponicPercentage == 100) {
    TotalFlatbed = TotalBlocks8X4Mtr * 2;
  }

  let AFrameBlock20ft = Math.floor(UsableWidth / 20);
  let calculatedValue = (UsableWidth / 20 - AFrameBlock20ft) * 20;
  let ExtraAFrameBlockinft = calculatedValue <= 8 ? 0 : calculatedValue;
  let TotalAFrameBlocks = AFrameBlock20ft * 3 * LengthBreakdown;
  let AFrameperline = AFrameBlock20ft * 6;
  let calculatedValueAFrameExtra = Math.ceil(
    (ExtraAFrameBlockinft - 2) / 3.5 + 1
  );
  let AFrameExtra =
    calculatedValueAFrameExtra <= 1 ? 0 : calculatedValueAFrameExtra;

  let Aframelines = Math.floor(Lenghtinft / 7);
  let TotalAframes = AFrameperline * 6 + AFrameExtra * 3 * LengthBreakdown;
  let NFTpipesinFt =
    (AFrameBlock20ft * 20 + ExtraAFrameBlockinft) * Aframelines;
  let Layer7Pipesft = NFTpipesinFt * 14;
  let TotalNumberofPipes = Layer7Pipesft / 20;
  let Foggers = TotalBlocks8X4Mtr * 2;
  let FoggerLatteralPipe = Foggers * 4 + 12;
  let TotalNewFlatbedInstallation = TotalBlocks8X4Mtr * 2;

  /// CEA - NVPH
  let OD76Pipe = Math.ceil(
    (6500 * WidthBreakdown * 2 +
      4500 * ((WidthBreakdown + 1) * (LengthBreakdown + 1))) /
      6000
  );
  let OD60Pipe = Math.ceil(
    (1000 *
      ((LengthBreakdown + 1) * (WidthBreakdown + 1) + WidthBreakdown * 2) +
      8000 * ((LengthBreakdown - 1) * WidthBreakdown) +
      4000 * WidthBreakdown * 4 +
      2000 * ((LengthBreakdown - 1) * WidthBreakdown)) /
      6000
  );
  let OD48Pipe = Math.ceil(
    (5500 * ((LengthBreakdown + 1 + (WidthBreakdown * 2 + 1)) * 2)) / 6000
  );
  let OD42Pipe = Math.ceil(
    (4000 * (LengthBreakdown * WidthBreakdown) +
      4000 * (LengthBreakdown * 2) +
      4000 * ((LengthBreakdown - 1) * 2 * (WidthBreakdown - 1)) +
      6000 * (WidthBreakdown * 2 - 2) +
      5500 * ((LengthBreakdown + 1) * WidthBreakdown) +
      4300 * ((LengthBreakdown + 1) * WidthBreakdown) +
      1200 * ((LengthBreakdown + 1 + (WidthBreakdown * 2 + 1)) * 2) +
      4000 * (LengthBreakdown * 2 + WidthBreakdown * 4)) /
      6000
  );
  let OD33Pipe = Math.ceil(
    (4000 * (WidthBreakdown * 2 + LengthBreakdown * 2) +
      5000 * (WidthBreakdown * 4) +
      1500 * ((LengthBreakdown + 1) * 2 * WidthBreakdown) +
      1840 * ((LengthBreakdown + 1) * 2 * WidthBreakdown)) /
      6000
  );

  let OD27Pipe = Math.ceil(
    (1000 * ((LengthBreakdown + 1) * WidthBreakdown) +
      6000 * (((AvailableWidth + 1) * 2 + (AvailableLength + 1) * 2) / 6)) /
      6000
  );

  const handelSubmit = (values) => {
    values = { ...values, origin: `polyhouseLayout-${length}m-${width}m` };
    setLoading(true);
    performRequest("POST", "/enquiryWebhook/createEnquiry/", values)
      .then((res) => {
        if (res.status === 201)
          Toast("success", "Enquiry Created Successfully!");
        else Toast("error", "Error while uploading");
      })
      .catch(CustomErrorResponse)
      .finally(() => setLoading(false));
  };

  const downloadImage = async (url, fileName) => {
    try {
      const response = await fetch(url, { mode: "cors" });
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const lengths = [
    8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 72, 76, 80,
    84, 88, 92, 96, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140, 144,
  ];

  const widths = [
    20, 28, 36, 44, 52, 60, 68, 76, 84, 92, 100, 108, 116, 124, 132, 140, 148,
  ];

  let currentWidth = width;
  let currentLength = length;

  const suggestedByLength = widths
    .filter((w) => w !== currentWidth)
    .map((w) => ({ l: currentLength, w }));

  // All other lengths for current width
  const suggestedByWidth = lengths
    .filter((l) => l !== currentLength)
    .map((l) => ({ l, w: currentWidth }));

  // Merge suggestions
  const suggestedSizes = [...suggestedByLength, ...suggestedByWidth];

  if (loading) return <LoadingPage />;

  return (
    <div>
      {/* ✅ SEO IMAGE FALLBACK — GOOGLE FRIENDLY */}
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          width: "1px",
          height: "1px",
          overflow: "hidden",
          clip: "rect(0 0 0 0)",
        }}
      >
        <img
          src={images.foundImg}
          alt={`Polyhouse foundation layout ${length}x${width}`}
          width="1200"
          height="800"
        />
        <img
          src={images.sideView}
          alt={`Polyhouse side view layout ${length}x${width}`}
          width="1200"
          height="800"
        />
        <img
          src={images.centerView}
          alt={`Polyhouse center view layout ${length}x${width}`}
          width="1200"
          height="800"
        />
        <img
          src={images.endView}
          alt={`Polyhouse end view layout ${length}x${width}`}
          width="1200"
          height="800"
        />
      </div>

      <Helmet>
        {/* Dynamic Page Title */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              name: `Polyhouse construction layout ${length}x${width}`,
              url: `https://alpha.kryzen.com/polyhouse-construction-layout/${length}/${width}`,
              primaryImageOfPage: images.foundImg
                ? {
                    "@type": "ImageObject",
                    contentUrl: images.foundImg,
                    name: `Polyhouse foundation layout ${length}x${width}`,
                    caption: `Foundation system layout of ${length}x${width} polyhouse`,
                    representativeOfPage: true,
                  }
                : undefined,
              image: [
                images.foundImg && {
                  "@type": "ImageObject",
                  contentUrl: images.foundImg,
                  name: `Polyhouse foundation layout ${length}x${width}`,
                  caption: `Foundation system layout of ${length}x${width} polyhouse`,
                },
                images.sideView && {
                  "@type": "ImageObject",
                  contentUrl: images.sideView,
                  name: `Polyhouse side view ${length}x${width}`,
                  caption: `Side view layout of ${length}x${width} polyhouse`,
                },
                images.centerView && {
                  "@type": "ImageObject",
                  contentUrl: images.centerView,
                  name: `Polyhouse center view ${length}x${width}`,
                  caption: `Center view layout of ${length}x${width} polyhouse`,
                },
                images.endView && {
                  "@type": "ImageObject",
                  contentUrl: images.endView,
                  name: `Polyhouse end view ${length}x${width}`,
                  caption: `End view layout of ${length}x${width} polyhouse`,
                },
              ].filter(Boolean),
            }),
          }}
        />

        <link rel="preload" as="image" href={images.foundImg} />

        <title>
          Polyhouse Layout {length}m × {width}m | Foundation, Side & Center
          Views
        </title>

        {/* Meta Description */}
        <meta
          name="description"
          content={`Explore the foundation, side, and center view layouts for a ${length}m × ${width}m polyhouse. Detailed structural design, ventilation, irrigation setup, and crop arrangement for modern protected cultivation.`}
        />

        {/* Meta Keywords */}
        <meta
          name="keywords"
          content={`
      ${length}m × ${width}m polyhouse layout,
      polyhouse foundation view ${length}m × ${width}m,
      polyhouse side view ${length}m × ${width}m,
      polyhouse center view ${length}m × ${width}m,
      greenhouse layout ${length}m × ${width}m,
      protected cultivation layout ${length}m × ${width}m,
      polyhouse design ${length}m × ${width}m,
      Kryzen Biotech polyhouse ${length}m × ${width}m
    `}
        />

        {/* Open Graph / Social Sharing */}
        <meta
          property="og:title"
          content={`${length}m × ${width}m Polyhouse Layout | Foundation, Side & Center Views`}
        />
        <meta
          property="og:description"
          content={`See detailed layouts for a ${length}m × ${width}m polyhouse, including foundation, side, and center views with ventilation, irrigation, and crop arrangements.`}
        />
        <meta
          property="og:image"
          content={
            images.foundImg ||
            images.centerView ||
            images.sideImg ||
            images.endView
          }
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`https://alpha.kryzen.com/polyhouse-construction-layout/${length}x${width}`}
        />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href={`https://alpha.kryzen.com/polyhouse-construction-layout/${length}x${width}`}
        />
      </Helmet>
      {/* Hero Section */}
      <header className="text-center mb-5 mt-5">
        <h1 className="fw-bold display-5 text-uppercase">
          {length}m × {width}m{" "}
          <span className="text-green">Polyhouse Layout</span>
        </h1>
        <p className="fs-1 fw-bold px-4">
          Explore detailed layouts and structural views of the {length} ×{" "}
          {width} polyhouse — including foundation, side view, and center view
          images.
        </p>
        <hr />
      </header>

      <div className="px-3 px-md-8 ms-md-8 me-md-8  py-4">
        <div className="row">
          <div className="col-12 col-md-3 col-lg-4  ps-md-5 pe-md-5">
            <div className="mt-2">
              {/* Form Section */}
              <div>
                <Formik
                  initialValues={enquiryInfo}
                  validationSchema={enquirySchema}
                  onSubmit={handelSubmit}
                  enableReinitialize
                >
                  {(props) => (
                    <Form
                      className="card p-3 p-md-5 bg-green-lt"
                      // style={{ backgroundColor: "lightgreen" }}
                    >
                      <h2
                        className="fs-1 fs-md-3 text-center mb-3"
                        style={{ color: "black" }}
                      >
                        Join an expert call for {length}m × {width}m Polyhouse
                        Layout.
                      </h2>
                      <hr></hr>
                      <div className="mb-3">
                        <label
                          className="form-label required"
                          style={{ color: "black" }}
                        >
                          First Name
                        </label>
                        <CustomInput name="firstName" type="text" />
                        {props.touched.firstName && props.errors.firstName && (
                          <p className="text-danger">
                            {props.errors.firstName}
                          </p>
                        )}
                      </div>

                      <div className="mb-3">
                        <label
                          className="form-label required"
                          style={{ color: "black" }}
                        >
                          Last Name
                        </label>
                        <CustomInput name="lastName" type="text" />
                        {props.touched.lastName && props.errors.lastName && (
                          <p className="text-danger">{props.errors.lastName}</p>
                        )}
                      </div>

                      <div className="mb-3">
                        <label
                          className="form-label required"
                          style={{ color: "black" }}
                        >
                          Mobile Number
                        </label>
                        <CustomInput name="mobileNumber" type="text" />
                        {props.touched.mobileNumber &&
                          props.errors.mobileNumber && (
                            <p className="text-danger">
                              {props.errors.mobileNumber}
                            </p>
                          )}
                      </div>

                      <div className="mb-3">
                        <label
                          className="form-label"
                          style={{ color: "black" }}
                        >
                          Email
                        </label>
                        <CustomInput name="email" type="text" />
                        {props.touched.email && props.errors.email && (
                          <p className="text-danger">{props.errors.email}</p>
                        )}
                      </div>

                      <div className="text-center mt-3">
                        {/* <FormSubmitButton buttonText="Submit" /> */}
                        <button
                          class="btn btn-github  btn mx-1 mt-2 text-center"
                          isSubmitting={props.isSubmitting}
                        >
                          <BsBoxArrowInRight className="fs-2 me-2"></BsBoxArrowInRight>
                          Submit
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
            <div className=" mt-5">
              <div className="card table-responsive">
                <div className="card-header text-center fs-1  fw-bold">
                  Specifications
                </div>
                <table className="table table-vcenter border">
                  <thead>
                    <tr>
                      <th>Sr</th>
                      <th>Item Name</th>
                      <th>Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{++indexCount}</td> <td>SqMtr</td>
                      <td>{Sqmtr}</td>
                    </tr>
                    <tr>
                      <td>{++indexCount}</td> <td>SqFt</td>
                      <td>{SqFt}</td>
                    </tr>
                    <tr>
                      <td>{++indexCount}</td> <td>Usable SqMtr</td>
                      <td>{UsableSqMtr}</td>
                    </tr>
                    <tr>
                      <td>{++indexCount}</td> <td>Length (div / 4)</td>
                      <td>{length}</td>
                    </tr>
                    <tr>
                      <td>{++indexCount}</td> <td>Width (div / 8)</td>
                      <td>{width}</td>
                    </tr>
                    <tr>
                      <td>{++indexCount}</td> <td>Hockey</td>
                      <td>{4}</td>
                    </tr>
                    <tr>
                      <td>{++indexCount}</td> <td>Avl Length / 4</td>
                      <td>{AvailableLength}</td>
                    </tr>
                    <tr>
                      <td>{++indexCount}</td> <td>Avl Width / 8</td>
                      <td>{AvailableWidth}</td>
                    </tr>
                    <tr>
                      <td>{++indexCount}</td> <td>Length Breakdown</td>
                      <td>{LengthBreakdown}</td>
                    </tr>
                    <tr>
                      <td>{++indexCount}</td> <td>Width Breakdown</td>
                      <td>{WidthBreakdown}</td>
                    </tr>
                    <tr>
                      <td>{++indexCount}</td>
                      <td>Total Blocks (8X4Mtr)</td>
                      <td>{TotalBlocks8X4Mtr}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="mt-5 border">
                <img
                  className="w-100"
                  style={{ height: "750px" }}
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844954/sidebar_id3qyb.jpg"
                  alt="conditions img"
                />
              </div>
            </div>
            <div className="mt-5 card p-4">
              <h2 className="fw-bold fs-1 mb-3 text-center">
                <span className="text-green">
                  Benefits of {length}m × {width}m
                </span>{" "}
                Polyhouse Layout
              </h2>
              <hr></hr>
              <p className="fs-2">
                A {length}m × {width}m polyhouse layout offers an optimized
                structure for
                <strong> protected cultivation</strong>, ensuring the right
                balance between space, ventilation, and sunlight. It allows
                farmers to grow crops year-round under controlled environmental
                conditions while reducing water consumption and improving
                productivity.
              </p>
              <ul className="fs-2 mt-3">
                <li>✔️ Enhanced crop yield and faster growth</li>
                <li>✔️ Better protection from pests, heat, and heavy rain</li>
                <li>✔️ Suitable for vegetables, flowers, and exotic crops</li>
                <li>✔️ Efficient irrigation and ventilation design</li>
                <li>✔️ Long-lasting galvanized steel structure</li>
              </ul>
            </div>

            <div className="mt-5 card">
              {/* Image Section */}
              <div className="col-12 ">
                <img
                  className="card img-fluid"
                  style={{
                    maxHeight: "500px",
                    width: "100%",
                    objectFit: "cover",
                  }}
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1756358719/shark_tank_uvzuuq.jpg"
                  alt="Shark Tank"
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-md-9 col-lg-8 ps-0 ps-md-4 card mt-2">
            {/* Foundation Section */}
            {images.foundImg && (
              <section className="row align-items-center mb-5">
                <div className="col-md-12">
                  <h2 className="fs-1 mt-3 p-2">
                    <b>
                      <span className="text-green">Foundation</span> Layout
                    </b>
                  </h2>
                  <hr />
                  <p className="fs-2 p-2">
                    The <strong>foundation plan</strong> for a {length} ×{" "}
                    {width} polyhouse ensures strong footing and long-term
                    durability. This layout highlights the exact placement of
                    columns, footings, and structural supports that form the
                    base of your greenhouse.
                  </p>
                  <p className="fs-2 p-2">
                    A solid foundation improves resistance against wind loads,
                    rainfall, and weather fluctuations. It also guarantees that
                    the structure remains upright and secure throughout its
                    lifespan.
                  </p>
                </div>

                <div
                  className="col-md-12 mb-3 mt-5 text-center"
                  style={{ overflow: "auto", maxHeight: "800px" }}
                >
                  <img
                    src={images.foundImg}
                    alt={`Polyhouse foundation layout ${length}x${width} meter showing footing, column spacing and base structure`}
                    title={`Polyhouse foundation system layout ${length}x${width} meter`}
                    width="1200"
                    height="800"
                    loading="eager"
                    fetchpriority="high"
                    decoding="async"
                    className="border"
                  />
                </div>
                <br />
                <div className="text-center">
                  <button
                    onClick={() =>
                      downloadImage(
                        images.foundImg,
                        `foundation-${length}x${width}.jpg`
                      )
                    }
                    className="btn btn-green btn-sm m-2"
                    style={{ width: "80px" }}
                  >
                    Download
                  </button>
                </div>
                <hr />
              </section>
            )}

            {/* Side View Section */}
            {images.sideView && (
              <section className="row align-items-center mb-5 flex-md-row-reverse">
                <div className="col-md-12">
                  <h2 className="fs-1 p-2">
                    <b>
                      <span className="text-green">Side</span> View
                    </b>
                  </h2>
                  <hr></hr>
                  <p className="fs-2 p-2">
                    The side view illustrates the{" "}
                    <strong>height and spacing</strong> of structural columns.
                    Proper spacing ensures excellent air circulation and
                    sunlight penetration into the polyhouse.
                  </p>
                  <p className="fs-2 p-2">
                    This perspective also helps farmers plan for maintenance
                    paths, sidewall coverings, and ventilation systems that
                    optimize crop growth conditions.
                  </p>
                </div>
                <div className="col-md-12 text-center mb-3">
                  <img
                    src={images.sideView}
                    alt={`Polyhouse side view layout ${length}x${width} meter showing structure and ventilation`}
                    title={`Polyhouse side view layout of ${length}x${width} meter polyhouse`}
                    width="1200"
                    height="800"
                    loading="lazy"
                    decoding="async"
                    className="border card p-3"
                  />
                  <br />
                  <button
                    onClick={() =>
                      downloadImage(
                        images.sideView,
                        `side-view-${length}x${width}.jpg`
                      )
                    }
                    className="btn btn-green btn-sm m-2"
                  >
                    Download
                  </button>
                </div>
                <hr></hr>
              </section>
            )}

            {/* Center View Section */}

            {images.centerView && (
              <section className="row align-items-center mb-5 flex-md-row-reverse">
                <div className="col-md-12">
                  <h2 className="fs-1 p-2">
                    <b>
                      <span className="text-green">Center</span> View
                    </b>
                  </h2>
                  <hr></hr>
                  <p className="fs-2 p-2">
                    The center view provides a clear look at the{" "}
                    <strong>working area</strong> inside the polyhouse. It
                    demonstrates crop arrangement, irrigation layout, and the
                    central ventilation system.
                  </p>
                  <p className="fs-2 p-2">
                    This view ensures uniform growth by showing how airflow and
                    sunlight distribution are maintained across the structure.
                  </p>
                </div>
                <div className="col-md-12 text-center mb-3 mt-8">
                  <img
                    src={images.centerView}
                    alt={`Polyhouse center view layout ${length}x${width} meter showing crop arrangement and irrigation system`}
                    title={`Polyhouse center view layout of ${length}x${width} meter polyhouse`}
                    width="1200"
                    height="800"
                    loading="lazy"
                    decoding="async"
                    className="border card p-3"
                  />
                  <br />
                  <button
                    onClick={() =>
                      downloadImage(
                        images.centerView,
                        `center-view-${length}x${width}.jpg`
                      )
                    }
                    className="btn btn-green btn-sm m-2"
                  >
                    Download
                  </button>
                </div>
                <hr></hr>
              </section>
            )}

            {images.endView && (
              <section className="row align-items-center mb-5 flex-md-row-reverse">
                <div className="col-md-12">
                  <h2 className="fs-1 p-2">
                    <b>
                      <span className="text-green">End</span> View
                    </b>
                  </h2>
                  <hr></hr>
                  <p className="fs-2 p-2">
                    The end view provides a clear look at the{" "}
                    <strong>working area</strong> inside the polyhouse. It
                    demonstrates crop arrangement, irrigation layout, and the
                    central ventilation system.
                  </p>
                  <p className="fs-2 p-2">
                    This view ensures uniform growth by showing how airflow and
                    sunlight distribution are maintained across the structure.
                  </p>
                </div>
                <div className="col-md-12 text-center mb-3 mt-8">
                  <img
                    src={images.endView}
                    alt={`Polyhouse end view layout ${length}x${width} meter showing elevation, structure, and ventilation`}
                    title={`Polyhouse end view layout of ${length}x${width} meter polyhouse`}
                    width="1200"
                    height="800"
                    loading="lazy"
                    decoding="async"
                    className="border card p-3"
                  />
                  <br />
                  <button
                    onClick={() =>
                      downloadImage(
                        images.endView,
                        `end-view-${length}x${width}.jpg`
                      )
                    }
                    className="btn btn-green btn-sm m-2"
                  >
                    Download
                  </button>
                </div>
              </section>
            )}
          </div>
        </div>
        {/* SEO CONTENT START */}

        <div className="section my-5 py-4">
          <div className="row text-center my-6">
            <hr></hr>
            <h2 className="hero-title display-6 fw-bold text-uppercase">
              FAQ’s About {length}m × {width}m Polyhouse
            </h2>
            <h3 className="section-description my-0 p-0 fs-2">
              Common questions about design, cost, and hydroponic setup.
            </h3>
          </div>
          <hr></hr>

          <div className="row mt-5">
            {/* Left Column */}
            <div className="col-md-6 col-sm-12">
              <div className="accordion" id="accordion-left">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-1"
                      aria-expanded="false"
                    >
                      What is the ideal crop for a {length}m × {width}m
                      polyhouse?
                    </button>
                  </h2>
                  <div
                    id="faq-1"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordion-left"
                  >
                    <div className="accordion-body fs-2">
                      High-value crops like tomato, capsicum, cucumber, lettuce,
                      and strawberry can be efficiently grown in a {length}m ×{" "}
                      {width}m polyhouse under controlled conditions.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-2"
                      aria-expanded="false"
                    >
                      What is the construction cost of {length}m × {width}m
                      polyhouse?
                    </button>
                  </h2>
                  <div
                    id="faq-2"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordion-left"
                  >
                    <div className="accordion-body fs-2">
                      The cost varies depending on materials, automation level,
                      and crop type. Typically ranges between ₹15–₹25 lakh for a{" "}
                      {length}m × {width}m polyhouse.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-3"
                      aria-expanded="false"
                    >
                      Can hydroponic systems be installed in this layout?
                    </button>
                  </h2>
                  <div
                    id="faq-3"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordion-left"
                  >
                    <div className="accordion-body fs-2">
                      Yes! This layout supports NFT, DFT, Dutch bucket, and
                      growbag hydroponic systems tailored to crop and space
                      requirements.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-md-6 col-sm-12">
              <div className="accordion" id="accordion-right">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-4"
                      aria-expanded="false"
                    >
                      How long does it take to build a {length}m × {width}m
                      polyhouse?
                    </button>
                  </h2>
                  <div
                    id="faq-4"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordion-right"
                  >
                    <div className="accordion-body fs-2">
                      Construction usually takes 45–60 days including
                      foundation, structure, covering, and installation of
                      irrigation systems.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-5"
                      aria-expanded="false"
                    >
                      Can the design be customized for specific crops?
                    </button>
                  </h2>
                  <div
                    id="faq-5"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordion-right"
                  >
                    <div className="accordion-body fs-2">
                      Absolutely! The {length}m × {width}m design can be
                      customized for crop type, hydroponic system, and
                      irrigation layout.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-6"
                      aria-expanded="false"
                    >
                      Who provides technical support and layout guidance?
                    </button>
                  </h2>
                  <div
                    id="faq-6"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordion-right"
                  >
                    <div className="accordion-body fs-2">
                      Professional guidance is provided for structural design,
                      irrigation layout, and hydroponic setup to ensure
                      efficient crop growth.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card p-4">
          <h2 className="fw-bold fs-1 mb-4 text-center">
            Explore Other Polyhouse Layout Sizes
          </h2>
          <p className="fs-2 text-center">
            Browse other popular polyhouse dimensions to compare space,
            structure, and cost before finalizing your ideal setup.
          </p>
          <div className=" text-center mt-3">
            {suggestedSizes
              .map((size) => (
                <a
                  key={`${size.l}x${size.w}`}
                  href={`/polyhouse-construction-layout/${size.l}/${size.w}`}
                  className="btn btn-outline-success rounded-pill m-1"
                >
                  {size.l}m × {size.w}m Layout
                </a>
              ))
              .slice(0, 18)}
          </div>
        </div>

        {/* SEO CONTENT END */}
        <hr></hr>
        <div className="row">
          <div className="col-12">
            <img
              className="w-100"
              // style={{ height: "380px" }}
              src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844969/footer_jclvvn.jpg"
              alt="footer img"
            ></img>
          </div>
        </div>
      </div>

      <FooterwithoutLogin></FooterwithoutLogin>
    </div>
  );
}

export default Polyhouseseopages;
